import { any } from 'prop-types';

import { Row, Col, Label, FormGroup, FormCard } from 'twyne-new.ui';

import Select from '@Components/form/Select';
import { useSelectOptions } from '@Stores/base-factories/store-list';
import Switch from 'components/form/Switch';

import { useUserStore } from '../store';

export default function AdminForm({ data: { organizationId, siteID, isSuperAdmin, isManagerAdmin } }) {
  const { lists: { sites, organizations } } = useUserStore()

  const siteOptions = useSelectOptions(sites)
  const organizationOptions = useSelectOptions(organizations)

  return <>
    <FormCard title='User settings' classNameBody='h-[225px]'>
      <Row>
        <Col size="12">
          <FormGroup>
            <Label>User Organization</Label>
            <Select options={organizationOptions} name="organizationId"
              value={organizationId} />
          </FormGroup>
        </Col>
        <Col size="12">
          <FormGroup>
            <Label>Site Registered</Label>
            <Select options={siteOptions} name="siteID"
              value={siteID} />
          </FormGroup>
        </Col>
        <Col size="6">
          <FormGroup>
            <Label>Super Admin</Label>
            <Switch name="isSuperAdmin" value={isSuperAdmin} />
          </FormGroup>
        </Col>
        <Col size="6">
          <FormGroup>
            <Label>Manager Admin</Label>
            <Switch name="isManagerAdmin" value={isManagerAdmin} />
          </FormGroup>
        </Col>
      </Row>
    </FormCard>
  </>
}

AdminForm.propTypes = {
  data: any,
};
